export const ChatFooterArrowRight = ({
  width,
  height,
  viewBox,
  fill,
  styles,
}) => {
  return (
    <svg
      width={width || '33'}
      height={height || '32'}
      viewBox={viewBox || '0 0 33 32'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles}
    >
      <rect x="0.550781" width="32" height="32" rx="16" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5508 3C9.37108 3 3.55078 8.8203 3.55078 16C3.55078 23.1797 9.37108 29 16.5508 29C23.7305 29 29.5508 23.1797 29.5508 16C29.5508 8.8203 23.7305 3 16.5508 3ZM22.2579 16.7071C22.4454 16.5196 22.5508 16.2652 22.5508 16C22.5508 15.7348 22.4454 15.4804 22.2579 15.2929L18.2579 11.2929C17.8674 10.9024 17.2342 10.9024 16.8437 11.2929C16.4532 11.6834 16.4532 12.3166 16.8437 12.7071L19.1366 15L11.5508 15C10.9985 15 10.5508 15.4477 10.5508 16C10.5508 16.5523 10.9985 17 11.5508 17L19.1366 17L16.8437 19.2929C16.4531 19.6834 16.4531 20.3166 16.8437 20.7071C17.2342 21.0976 17.8674 21.0976 18.2579 20.7071L22.2579 16.7071Z"
        fill={fill || '#63666F'}
      />
    </svg>
  );
};
